var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyLabelManagement = function SvgImgEmptyLabelManagement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(39 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.095 0c8.71 0 15.77 7.06 15.77 15.77v20.363c0 8.71-7.06 15.77-15.77 15.77s-15.77-7.06-15.77-15.77V15.77C2.325 7.06 9.385 0 18.095 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.317 41.565A12.36 12.36 0 0 0 21.57 40.4v-4.588h-6.815V40.4c-.96.276-1.882.668-2.747 1.166a12.543 12.543 0 0 0-5.112 5.577c1.693 3.15 6.816 3.015 11.134 3.015 4.317 0 9.62.627 11.4-3.014a12.543 12.543 0 0 0-5.113-5.579zM20.6 44.018s-.507-.968 2.51-.577m-7.548.577s.506-.968-2.511-.577m11.557-1.695v5.906m-13.021-5.906v5.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.68 47.715c-2.008.161-4.207.25-6.515.25a81.74 81.74 0 0 1-6.603-.257c-.405.865-2.598 1.567-5.48 1.792a12.28 12.28 0 0 0-.332 2.83v11.268h24.826V52.33c0-.951-.112-1.899-.33-2.824-2.919-.217-5.148-.922-5.566-1.792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.68 47.715c.418.87 2.647 1.575 5.565 1.792a12.336 12.336 0 0 0-.815-2.363m-22.534-.001c-.35.756-.623 1.546-.814 2.357 2.882-.225 5.075-.927 5.48-1.792"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M24.68 47.715c-2.008.161-4.207.25-6.515.25a81.74 81.74 0 0 1-6.603-.257c-.405.865-2.598 1.567-5.48 1.792a12.28 12.28 0 0 0-.332 2.83v11.268h24.826V52.33c0-.951-.112-1.899-.33-2.824-2.919-.217-5.148-.922-5.566-1.792z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.752,
    height: 31.135,
    x: 4.787,
    y: 7.302,
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 11.716
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.625 22.73a4.173 4.173 0 0 0 4.161 4.161V18.57a4.173 4.173 0 0 0-4.161 4.16zm30.918-4.161v8.322a4.161 4.161 0 0 0 0-8.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m19.865 9.217-5.459 4.833S8.5 16.376 8.052 16.287A40.342 40.342 0 0 0 3.4 17.36l.805-5.28 3.312-4.385s2.505-1.969 3.937-2.148c1.432-.179 6.533-.984 6.533-.984l4.295.716 3.311.984 2.774 1.79 2.059 1.969 1.52 3.4.806 3.4s-.179.448-.447.27c-.269-.18-5.638-1.701-5.638-1.701l-4.206-2.416-1.88-3.311-.715-.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.869 9.486c-.3 4.414-7.508 7.947-16.362 7.947m16.466-8.126c.23 4.414 5.783 7.947 12.603 7.947"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.045,
    cy: 22.551,
    r: 1.553,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.981,
    cy: 22.551,
    r: 1.553,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M13.962 30.726a4.503 4.503 0 0 0 4.051 2.78 4.503 4.503 0 0 0 4.051-2.78h-8.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26.845 26.757 1.342.805m-.671-1.745 1.342.806M7.55 26.69l1.341.805M8.22 25.75l1.343.806"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.445 4.363h13.323c5.631 0 10.196 4.565 10.196 10.197v4.337c0 5.631-4.565 10.197-10.196 10.197H13.445c-5.632 0-10.197-4.566-10.197-10.197V14.56c0-5.632 4.565-10.197 10.197-10.197zm6.572 38.592c-7.6.022-13.755 6.178-13.777 13.777v12.506h27.555V56.732c-.023-7.6-6.178-13.755-13.778-13.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.017 48.36a3.793 3.793 0 0 0 3.782-3.782v-6.18h-7.564v6.18a3.793 3.793 0 0 0 3.782 3.782z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.692,
    height: 34.814,
    x: 5.171,
    y: 6.498,
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 12.274
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.552 23.878a4.632 4.632 0 0 0 4.619 4.619V19.26a4.632 4.632 0 0 0-4.62 4.618zm34.316-4.618v9.237a4.619 4.619 0 0 0 0-9.237z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.227,
    cy: 23.68,
    r: 1.724,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.475,
    cy: 23.68,
    r: 1.724,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M15.355 32.754a4.82 4.82 0 0 0 8.993 0h-8.993z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.235 43.744v25.129M23.8 43.558v25.129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M6.24 56.732v12.506h9.995V43.49A13.83 13.83 0 0 0 6.24 56.732zm27.555 0a13.83 13.83 0 0 0-9.996-13.242v25.748h9.996V56.732z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.079 56.358-1.766 8.84m-14.374-8.84 1.765 8.84M32.161 1.63A3.54 3.54 0 0 0 31.762 0a3.583 3.583 0 0 1-3.176 1.945h-17.58a3.584 3.584 0 0 0-3.568 3.418c-.003.053-.008.105-.008.158v3.575a3.586 3.586 0 0 0 3.575 3.576h17.58a3.586 3.586 0 0 0 3.576-3.576V5.521c0-.053-.005-.105-.008-.158.003-.052.008-.104.008-.157V1.631zm-6.019 51.351h3.278"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 16,
    fill: "#FFF",
    stroke: "#BDBDBD",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 6,
    x: 5,
    y: 5,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 42,
    y: 5,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyLabelManagement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-label-management.3c59af22e19dcc38926bcca8935c7450.svg";